<tcc-mono-dialog-layout
  [title]="'Nieuw dier via levensnummer'"
  (onSave)="save()"
>
  <form [formGroup]="form" (ngSubmit)="save()">
    <ion-grid>
      <ion-row>
        <ion-col class="ion-padding">
          <ion-segment mode="ios" formControlName="country_code">
            <ion-segment-button value="NL">NL</ion-segment-button>
            <ion-segment-button value="DK">DK</ion-segment-button>
            <ion-segment-button value="BE">BE</ion-segment-button>
            <ion-segment-button value="DE">DE</ion-segment-button>
            <ion-segment-button value="FR">FR</ion-segment-button>
            <ion-segment-button value="IE">IE</ion-segment-button>
            <ion-segment-button value="LU">LU</ion-segment-button>
          </ion-segment>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-input
            mode="md"
            formControlName="identification_number"
            labelPlacement="stacked"
            fill="solid"
            errorText="Levensnummer is verplicht"
          >
            <ion-text slot="label" class="form-label required">
              Levensnummer
            </ion-text>
          </ion-input>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="mark-color-select">
            <ion-text class="mark-color-select-label">Kleur / Markering (welke stip erop)</ion-text>
            <div class="mark-color-dots" aria-label="Kies kleur">
              <button
                type="button"
                class="mark-color-dot mark-color-dot-none"
                [class.selected]="form.get('selection_mark_color')?.value == null"
                (click)="form.get('selection_mark_color')?.setValue(null)"
                title="Geen"
              ></button>
              <button
                *ngFor="let c of usedColors"
                type="button"
                class="mark-color-dot"
                [style.background-color]="getMarkColorHex(c.value)"
                [class.selected]="form.get('selection_mark_color')?.value === c.value"
                (click)="form.get('selection_mark_color')?.setValue(c.value)"
                [attr.title]="c.name"
              ></button>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</tcc-mono-dialog-layout>
